module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_A_2.e98a3f32.mp3";